(ns motorsaif.web.pages.generic
  (:require
   [motorsaif.frontend-routes :as routes]))

(defn terms []
  [:div.generic-info
   [:h1 "Terms and Conditions"]
   [:p "Welcome to MotorSaif! These terms and conditions outline the rules and regulations for the use of MotorSaif's website."]
   [:h2 "Introduction"]
   [:p "By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use MotorSaif's website if you do not accept all of the terms and conditions stated on this page."]
   [:h2 "Definitions"]
   [:p "\"User\" refers to any individual who uses the MotorSaif website to post requests or respond to them."]
   [:p "\"Business\" refers to any entity that responds to requests posted on the MotorSaif website."]
   [:h2 "Posting Requests"]
   [:p "Users are allowed to post requests on MotorSaif. The content of the requests must comply with the guidelines provided by MotorSaif. Users must not post any illegal, offensive, or inappropriate content."]
   [:h2 "Responding to Requests"]
   [:p "Businesses are allowed to respond to the requests posted by Users. Responses must be professional and relevant to the requests. Businesses must not post any misleading, false, or inappropriate information."]
   [:h2 "User Conduct"]
   [:p "Users must use the website in a manner that is ethical and in compliance with all applicable laws and regulations. Any form of harassment, abuse, or other harmful behavior will not be tolerated."]
   [:h2 "Intellectual Property"]
   [:p "Unless otherwise stated, MotorSaif and/or its licensors own the intellectual property rights for all material on the website. All intellectual property rights are reserved."]
   [:h2 "Limitation of Liability"]
   [:p "MotorSaif will not be held liable for any damages arising out of or in connection with the use of this website. This includes, without limitation, direct loss, loss of business or profits, damage caused to your computer, software, systems and programs, and the data thereon or any other direct or indirect, consequential, and incidental damages."]
   [:h2 "Changes to These Terms"]
   [:p "MotorSaif reserves the right to revise these terms and conditions at any time. By using this website, you are expected to review these terms on a regular basis to ensure you understand all terms and conditions governing the use of this website."]
   [:h2 "Governing Law"]
   [:p "These terms and conditions are governed by and construed in accordance with the laws of [Your Country/State], and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location."]
   [:h2 "Contact Information"]
   [:p "If you have any questions about these Terms and Conditions, please contact us at support@motorsaif.com."]])

(defn privacy []
  [:div.generic-info
   [:h1 "Privacy Policy"]
   [:h2 "Introduction"]
   [:p "Welcome to MotorSaif. We value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, disclose, and safeguard your information when you use our website."]
   [:h2 "Information We Collect"]
   [:p "We may collect personal information that you provide to us directly, such as your name, email address, phone number, and any other information you choose to provide when posting requests or responding to them. We also collect information automatically when you use our site, such as your IP address, browser type, and usage data."]
   [:h2 "How We Use Your Information"]
   [:p "We use the information we collect to:"]
   [:ul
    [:li "Provide and maintain our services"]
    [:li "Facilitate communication between users"]
    [:li "Respond to your inquiries and support requests"]
    [:li "Improve our website and services"]
    [:li "Send you updates, newsletters, and marketing communications"]]
   [:h2 "Information Sharing and Disclosure"]
   [:p "We do not sell or rent your personal information to third parties. We may share your information with third-party service providers who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also disclose your information if required by law or to protect our rights."]
   [:h2 "Security of Your Information"]
   [:p "We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the Internet, or method of electronic storage, is 100% secure, and we cannot guarantee absolute security."]
   [:h2 "Your Privacy Choices"]
   [:p "You can review, update, or delete your personal information by contacting us directly. You may also opt-out of receiving marketing communications from us by following the unsubscribe instructions included in those emails."]
   [:h2 "Changes to This Privacy Policy"]
   [:p "We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page. Your continued use of the site after any changes constitutes your acceptance of the new privacy policy."]
   [:h2 "Contact Us"]
   [:p "If you have any questions about this privacy policy, please contact us at:"]
   [:p "Email: support@motorsaif.com"]
   #_[:p "Phone: 123-456-7890"]])

(defn about []
  [:div.generic-info {:id "about"}
   [:h1 "About MotorSaif"]
   [:p "We built MotorSaif to solve a simple problem: connecting car owners with trusted local automotive professionals through intelligent matching and real-time communication."]
   [:h2 "What We Do"]
   [:p "Car owners post detailed requests for repairs, parts, or upgrades. Our platform instantly notifies relevant businesses based on location, expertise, and service capabilities. Direct communication happens through built-in messaging with status tracking from initial contact to job completion."]
   [:h2 "Why It Works"]
   [:p "Smart filters prevent spam. Geographic matching ensures relevance. Real-time notifications capture opportunities immediately. Both sides know exactly where they stand through our interaction status system."]
   [:h2 "Built Different"]
   [:p "No subscriptions. Just efficient connections between people who need automotive work and professionals who deliver quality results."]
   [:h2 "Get Started"]
   [:p "Car owners get faster responses and competitive quotes. Businesses grow their customer base with qualified leads."]
   [:h2 "Questions?"]
   [:p "Contact us at support@motorsaif.com"]])

(defn businesses []
  [:div.generic
   ;; Hero Section
   [:section.hero
    [:div.hero-content
     [:h1 "MotorSaif for Business"]
     [:p "Connect with customers actively seeking your services and transform how you grow your automotive business"]
     [:button.btn.primary.pill.cta-button "Get Started Free"]]]

   ;; Features Section
   [:section.features
    [:div.features-container
     [:h2.section-title "Why Choose MotorSaif?"]
     [:p.section-subtitle "Join thousands of businesses growing their customer base with our innovative platform designed for the automotive industry"]
     
     [:div.features-grid
      [:div.feature-card
       [:div.feature-icon
        [:i.fa-solid.fa-bullseye]]
       [:h3.feature-title "Targeted Leads"]
       [:p.feature-description "Receive leads specifically tailored to your business type and location, ensuring maximum relevance and conversion potential."]]
      
      [:div.feature-card
       [:div.feature-icon
        [:i.fa-solid.fa-comments]]
       [:h3.feature-title "Direct Communication"]
       [:p.feature-description "Connect with customers instantly through our built-in messaging system, eliminating barriers between you and your next client."]]
      
      [:div.feature-card.highlighted
       [:div.feature-icon
        [:i.fa-solid.fa-chart-line]]
       [:h3.feature-title "Grow Your Business"]
       [:p.feature-description "Expand your customer base and increase your revenue with quality leads that convert into long-term relationships."]]
      
      [:div.feature-card
       [:div.feature-icon
        [:i.fa-solid.fa-hand-holding-dollar]]
       [:h3.feature-title "Completely Free"]
       [:p.feature-description "No setup fees, no monthly charges, no hidden costs. 100% free to use and scale your business without limits."]]]]]

   ;; How It Works Section
   [:section.how-it-works
    [:div.how-it-works-container
     [:h2.section-title "How It Works"]
     [:p.section-subtitle "Getting started with MotorSaif is simple and straightforward"]
     
     [:ul.steps-list
      [:li.step-item
       [:div.step-content
        [:h3 "Customers post requests for motor services in your area"]
        [:p "Local customers actively seeking automotive services submit their requirements through our platform, creating immediate opportunities for your business."]]]
      [:li.step-item
       [:div.step-content
        [:h3 "You receive notifications for relevant opportunities"]
        [:p "Our intelligent matching system instantly notifies you when requests align with your services and location, ensuring you never miss a potential customer."]]]
      [:li.step-item
       [:div.step-content
        [:h3 "Connect directly with potential customers"]
        [:p "Engage with interested customers through our secure messaging platform, discuss their needs, and provide quotes in real-time."]]]
      [:li.step-item
       [:div.step-content
        [:h3 "Close more deals and grow your business"]
        [:p "Convert leads into loyal customers and build your reputation through successful service delivery and positive reviews."]]]]]]

   ;; Final CTA Section
   [:section.final-cta
    [:div.final-cta-content
     [:h2 "Ready to Get Started?"]
     [:p "Join MotorSaif today and start connecting with customers who need your services. Transform your business growth with our powerful platform."]
     [:button.btn.inverse-on-brand.pill.cta-button-white "Sign Up Now"]]]

   ;; Contact Section
   [:section.contact
    [:div.contact-container
     [:h2 "Get Started Today"]
     [:p "To begin your journey with MotorSaif, send an email with your business details. Our team will reach out to help you get set up quickly."]
     
     [:div.contact-info
      [:p "Contact us at " [:a.email-link {:href "mailto:business@motorsaif.com"} "business@motorsaif.com"] " and we'll get back to you within 24 hours."]
      [:p.contact-extra "Once you're onboarded, you'll gain access to our platform where you can view and respond to customer requests that matter to your business."]]

     [:h2.help-title "Need Help?"]
     [:p "Have questions about how MotorSaif works for businesses? Our support team is here to help you succeed."]]]])
